module.exports = __webpack_public_path__ + "img/logo.901fd2e9.svg";